import React from "react";
import { CardContent, Box, Skeleton } from "@mui/material";

const AddProblemSkeleton = ({ isUpdate, problemData }) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", height: "100%", gap: 2 }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box sx={{ mb: 2 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={200}
            sx={{ mb: 1 }}
            animation="wave"
          />
        </Box>

        {[...Array(8)].map((_, index) => (
          <Box key={index} sx={{ mb: 1 }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              animation="wave"
            />
          </Box>
        ))}
      </CardContent>
    </Box>
  );
};

export default AddProblemSkeleton;
